import { Group, UnstyledButton } from '@mantine/core';
import { ReactElement } from 'react';
import { ORBIT_DISABLED } from '@/theme/colors';
import { ConnectPatientPopover } from './ConnectPatientPopover';
import { LedgerCell, LedgerEmptyCell } from './LedgerCell';
import { canDisconnect, ConnectCandidate } from './ledgerConnect';
import { LedgerRow } from './ledgerRows';
import './ledger.css';

/** The patient, with Disconnect on hover; or the payer, greyed, with Connect. */
export function LedgerPatientCell({
  row,
  onConnect,
  onDisconnect,
}: {
  row: LedgerRow;
  onConnect: (row: LedgerRow, candidate: ConnectCandidate) => void;
  onDisconnect: (row: LedgerRow) => void;
}): ReactElement {
  if (row.patientDisplayName) {
    return (
      <Group gap={4} wrap="nowrap" className="ledger-patient" style={{ width: '100%' }}>
        <LedgerCell>{row.patientDisplayName}</LedgerCell>
        {canDisconnect(row) && (
          <UnstyledButton
            className="ledger-disconnect"
            title="Disconnect"
            aria-label="Disconnect"
            onClick={(event) => {
              event.stopPropagation();
              onDisconnect(row);
            }}
            style={{ color: ORBIT_DISABLED, fontSize: 13, lineHeight: 1, padding: '0 2px' }}
          >
            ×
          </UnstyledButton>
        )}
      </Group>
    );
  }

  return (
    <Group gap={6} wrap="nowrap" style={{ width: '100%' }}>
      {row.payerName ? (
        <LedgerCell color={ORBIT_DISABLED} title="Payer on the transaction" style={{ width: 'auto', minWidth: 0 }}>
          {row.payerName}
        </LedgerCell>
      ) : (
        <LedgerEmptyCell />
      )}
      <ConnectPatientPopover row={row} onPick={(candidate) => onConnect(row, candidate)} />
    </Group>
  );
}
